import {Deserializable} from './deserializable';


export class ItemsList<T> implements Deserializable {
  
  items: T[];

  deserialize(input: any) {
    
    Object.assign(this, input);
    if (!input) {
      return this;
    }

    return this;
  }
}
